var _excluded = ["at", "bt", "tt"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * @file 发送停留时长上报
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/stay
 */
import request from './util/request';
import configurable from './util/configurable';
import performance from './util/performance';
import { on, off } from './util/dom';
import { trackID, getUserID, Config, ROUTE_MODE, documentHidden, documentVisibilityChange, getInnerEventName } from './util/config';
import warnForbiddenKeys from './util/forbiddenWords';
import metric from './metric';
import onRouteChange from './util/onRouteChange';
import getPath from './util/getPath';
var win = typeof window !== 'undefined' && window;
var doc = win && document;

// 当前浏览器支持的 hidden 和 visibilityChange 写法
var _ref = [['hidden', 'visibilitychange'], ['webkitHidden', 'webkitvisibilitychange'], ['mozHidden', 'mozvisibilitychange'], ['msHidden', 'msvisibilitychange']].filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      key = _ref4[0];
    return key in (doc || {});
  })[0] || [],
  _ref2 = _slicedToArray(_ref, 2),
  hidden = _ref2[0],
  visibilityChange = _ref2[1];

// 进入页面时间戳
var start = performance.timing && performance.timing.responseEnd || +new Date();

// 跳出时间
var bounceTimes = 0;

// 活动时间
var activeTime = 0;

// 最后活动时间
var lastActiveTime = start;

// 切换路由，销毁监听
var teardown;

/**
 * 上一个页面的 URL，对于 SPA 来说是上一个路由的地址
 */
var previousPageURL = '';

/**
 * 上一个页面的 href
 */
var previousPageHref = '';

// 停留时长统计
var changeCount = function changeCount() {
  var now = +new Date();
  if (doc[documentHidden]) {
    if (bounceTimes) {
      activeTime += now - lastActiveTime;
    } else {
      activeTime = now - start;
    }
    bounceTimes++;
  } else {
    lastActiveTime = now;
  }
};
on(doc, documentVisibilityChange, changeCount);

/**
  * 时长上报
  *
  * @function
  * @param {Object} json 要上报的数据
  * @param {Function=} callback 上报后的回调
  */
var report = configurable(function (json, callback) {
  var now = +new Date();

  // 三个重要指标，避免覆盖真实统计值（作弊）
  /* eslint-disable no-unused-vars */
  var at = json.at,
    bt = json.bt,
    tt = json.tt,
    rest = _objectWithoutProperties(json, _excluded);
  /* eslint-enable no-unused-vars */

  // 要上报的数据
  var stayData = _objectSpread({
    // 当前页面 URL
    url: previousPageHref,
    // 用户的唯一标识，由后端生成写到 cookie 中
    uuid: trackID,
    // 登录用户 ID，用户登录后端写到 cookie 中
    uid: getUserID(),
    // 页面路径归类
    path: previousPageURL,
    // Active Time 活动时长
    at: activeTime + (now - lastActiveTime),
    // Bounce Times 切换次数
    bt: bounceTimes,
    // Total Time 总停留时长
    tt: now - start
  }, rest);

  // 上报后重置相关统计
  activeTime = 0;
  bounceTimes = 0;
  start = lastActiveTime = now;
  previousPageURL = getPath();
  previousPageHref = location.href;
  warnForbiddenKeys(stayData);
  // 为保证上报成功和简化逻辑，只支持 POST 方式的上报
  request('post', true)("".concat(Config.STAY), stayData, callback);

  // 自动上报点击指标数据到轻舟
  metric(_objectSpread(_objectSpread({}, stayData), {}, {
    metric: 'stay'
  }));
}, {});
function observe() {
  report({});
}

/**
  * 解除相关事件的绑定
  */
function destroy() {
  off(doc, visibilityChange, changeCount);
  off(doc, documentVisibilityChange, changeCount);
  off(win, getInnerEventName('pushstate'), observe);
  off(win, getInnerEventName('replacestate'), observe);
  off(win, 'popstate', observe);
  off(win, 'hashchange', observe);
  off(win, 'beforeunload', observe);
  off(win, 'unload', destroy);
  typeof teardown === 'function' && teardown();
}
report.init = function (number) {
  if (Object.values(ROUTE_MODE).includes(+number)) {
    Config.ROUTE_MODE = +number;
  }
  previousPageURL = getPath();
  previousPageHref = location.href;
  teardown = onRouteChange(function (e) {
    observe();
  });
};
on(win, 'beforeunload', observe);
on(win, 'unload', destroy);
export default report;